import { render, staticRenderFns } from "./initial_info.vue?vue&type=template&id=7f271725&scoped=true"
import script from "./initial_info.vue?vue&type=script&lang=js"
export * from "./initial_info.vue?vue&type=script&lang=js"
import style0 from "./initial_info.vue?vue&type=style&index=0&id=7f271725&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f271725",
  null
  
)

export default component.exports